import { useState } from 'react'

type Field<T, U extends keyof T = keyof T> = {
  key: U
  value: T[U]
}

export type UseDataManagerUpdateFields<T> = (index: number, fields: Field<T>[]) => void

type UseDataManager<T> = {
  data: T[]
  setData: (data: T[]) => void
  updateFields: UseDataManagerUpdateFields<T>
  removeItem: (index: number) => void
  addItem: (item: T) => void
}

export const useDataManager = <T>(initialData: T[]): UseDataManager<T> => {
  const [data, setData] = useState<T[]>(initialData)

  const updateFields = (index: number, fields: Field<T>[]) => {
    // Example logic: updating the fields of the item at the given index
    const updatedData = [...data]
    const item = updatedData[index]

    if (item) {
      for (const field of fields) item[field.key] = field.value as never
      setData(updatedData)
    }
  }

  const removeItem = (index: number) => {
    const updatedData = [...data]
    updatedData.splice(index, 1)
    setData(updatedData)
  }

  const addItem = (item: T) => {
    setData([...data, item])
  }

  return { data, setData, updateFields, removeItem, addItem }
}
